/* eslint class-methods-use-this: ["error", { "exceptMethods": ["isAuthenticated"] }] */
let instance = null;

export default class Language {
  constructor(defaultLang = 'en') {
    this.defaultLang = defaultLang;
    this.availablesLocales = ['es', 'en', 'ca'];
    this.delimiters = /-|_/; // 'es-ES' or 'es_ES'
    this.exceptionsLocales = ['es', 'fr']; // 'es-CA' or 'fr-BE'
    this.dictionary = {
      es: 'es_ES',
      en: 'en_GB',
      ca: 'ca_ES',
      gb: 'en_GB',
    };
    this.forceLanguage = null;
  }

  static get instance() {
    return instance;
  }

  static set instance(val) {
    instance = val;
  }

  getLanguage() {
    if (this.forceLanguage) {
      return this.forceLanguage;
    }
    const { defaultLang } = this;
    // const defaultLang = this.defaultLang;
    const browserLanguage = this.getBrowserLanguage();

    let language = browserLanguage[0] || defaultLang;

    if (this.exceptionsLocales.indexOf(browserLanguage[0]) > -1 && browserLanguage[1]) {
      language = browserLanguage[1].toLowerCase();
    }

    language = this.availablesLocales.indexOf(language) > -1 ? language : defaultLang;
    return language;
  }

  setForceLanguage(locale) {
    if (!this.isLocaleValid(locale)) {
      throw new Error('Locale is not valid');
    }

    this.forceLanguage = locale;
  }

  getBrowserLanguage() {
    const hlURL = new URLSearchParams(window.location.search).get('hl');
    const languageURL = new URLSearchParams(window.location.search).get('language');

    const localeURL = hlURL || languageURL;

    // Check when hl parameter is similar to 'es', 'ca', 'en'...
    const isValidLocale = localeURL && this.getLanguageCodeFromLocale(localeURL);
    if (isValidLocale) {
      return [localeURL];
    }

    // Check when hl parameter is similar to 'es_ES', 'en_GB', ....
    const locale = localeURL && this.getLocaleFromLanguageCode(localeURL);
    if (locale) {
      return [locale];
    }

    // If hl parameter does not exist, get the browser language
    const browserLanguage = window.navigator.userLanguage || window.navigator.language;

    return browserLanguage.split(this.delimiters);
  }

  /**
   * Get de Language code to be passed to backend
   * @param locale
   */
  getLanguageCodeFromLocale(locale = '') {
    const l = Object.keys(this.dictionary).find(i => i === locale.toLowerCase());
    return this.dictionary[l];
  }

  isLanguageCodeValid(code = '') {
    return !!Object.values(this.dictionary).find(i => i.toLowerCase() === code.toLowerCase());
  }

  isLocaleValid(locale = '') {
    return !!Object.keys(this.dictionary).find(i => i.toLowerCase() === locale.toLowerCase());
  }

  getLocaleFromLanguageCode(languageCode) {
    return Object.keys(this.dictionary).filter((i) => {
      const dictionaryCode = this.dictionary[i].replace('-', '_');
      const languageCodeReplace = languageCode.replace('-', '_');
      return dictionaryCode.toLowerCase() === languageCodeReplace.toLowerCase();
    })[0] || null;
  }

  static create(defaultLang = 'en') {
    Language.instance = new Language(defaultLang.toLowerCase());
    return Language.instance;
  }

  static getInstance() {
    return Language.instance || Language.create();
  }
}
